<template>
  <div class="printerList">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('CloudPrinter')" name="cloud">
        <div class="container" v-if="printer_list.length > 0">
          <div
            class="cardItem"
            v-for="(item, index) of printer_list"
            :key="index"
          >
            <printerItem :printerInfo="item"></printerItem>
          </div>
        </div>
        <div class="no-printer-box" v-else>
          <img src="@/assets/imgs/noPrinterLists.png" alt="" />
          <div class="no-printer-text">{{ $t("no_printer_connected") }}</div>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('LANPrinter')" name="lan">
        <div
          class="container"
          v-if="$store.getters.GET_LAN_PRINTER_LIST.length > 0"
        >
          <div
            class="cardItem"
            v-for="(item, index) of $store.getters.GET_LAN_PRINTER_LIST"
            :key="index"
          >
            <LanPrinterItem :printerInfo="item"></LanPrinterItem>
          </div>
        </div>
        <div class="no-printer-box" v-else>
          <img src="@/assets/imgs/noPrinterLists.png" alt="" />
          <div class="no-printer-text">{{ $t("no_printer_connected") }}</div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import printerItem from "./components/printerItem.vue";
import LanPrinterItem from "./components/LanPrinterItem.vue";
import { mapActions } from "vuex";
import { account } from "@/utils/account";
import { mapGetters } from "vuex";
export default {
  name: "printerList",
  components: {
    printerItem,
    LanPrinterItem,
  },
  data() {
    return {
      printerList: [],
      activeName: "cloud",
    };
  },
  computed: {
    ...mapGetters(["GET_TOKEN"]),
    printer_list() {
      return this.$store.getters.GET_CLOUD_PRINTER_LIST;
    },
    isOnline() {
      // 网络状态
      return this.$store.getters.GET_ISONLINE;
    },
  },
  created() {
    if (!this.GET_TOKEN) return;
    this.SET_LOADING_TRUE();
    this.$parent.getPrinters().then(() => {
      this.SET_LOADING_FALSE();
    });
  },
  mounted() {
    account.is_logined();
  },
  methods: {
    ...mapActions(["SET_LOADING_TRUE", "SET_LOADING_FALSE"]),
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__header {
  background-color: var(--dialog-background-color);
  margin-bottom: 10px;
}
::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px !important;
}
::v-deep .el-tabs {
  width: 100%;
  height: 100%;
}
::v-deep .el-tabs__item {
  color: var(--first-text-color);
}
::v-deep .el-tabs__item:hover,
::v-deep .is-active {
  color: #409eff !important;
}
::v-deep .el-tabs__content {
  width: 100%;
  height: calc(100% - 40px);
}
::v-deep .el-tab-pane {
  width: 100%;
  height: 100%;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: var(--dialog-background-color);
}

/* @import url(); 引入公共css类 */
.printerList {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: var(--workbench-base-color);
  .tool {
    display: flex;
    align-items: center;
    height: 46px;
    cursor: pointer;
    margin-left: 16px;
    img {
      width: 14px;
      height: 20px;
      margin-right: 8px;
    }
    span {
      height: 22px;

      font-weight: normal;
      font-size: 14px;
      color: var(--VI-color);
      line-height: 22px;
    }
    .tip {
      display: inline-block;
      margin: 0 8px;
      padding: 0 8px;
      height: 24px;
      background: rgba(255, 103, 0, 0.06);
      border-radius: 8px 8px 8px 8px;

      font-weight: normal;
      font-size: 13px;
      color: #ff6700;
      line-height: 24px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    // align-content: space-between;
    margin-bottom: -10px;
    .cardItem {
      width: 524px;
      margin: 0 10px 10px 0;
      cursor: pointer;
      background-color: var(--dialog-background-color);
      &:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }
}
@media screen and (max-width: 1919px) {
  .cardItem {
    &:nth-child(3n) {
      margin-right: 10px !important;
    }
  }
}
.no-printer-box {
  width: 100%;
  height: 100%;
  background-color: var(--dialog-background-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .no-printer-text {
    color: var(--first-text-color);
    font-size: 15px;
  }
}
</style>
